export default __webpack_public_path__ + "static/media/export_settings.2ca62af0.png";